import React from 'react'

import { NavLink } from 'react-router-dom'

import { SiteContext } from 'context/site-context'

import './index.scss'

const TopCities = () => {
  const [ site, setSite] = React.useContext(SiteContext)

  const handleCityClick = (e, location) => {
    localStorage.setItem('geoInfo', JSON.stringify({
      location: location,
      city: location.split(', ')[0],
      region_code: location.split(', ')[1],
    }))

    setSite({
      ...site,
      location: location,
    })
  }

  const getCities = () => site.popular_cities ? site.popular_cities.filter( city => city.isTop ) : []

  return <div className="top-cities-container">
    <ul>
      {getCities().map( city => {
        return <li key={city.label}><NavLink to={`/${city.label.split(', ')[1].toLowerCase()}/${city.label.split(', ')[0].toLowerCase()}${!!new URLSearchParams(window.location.search).get('useSampleData') ? '&useSampleData=true' : ''}`} onClick={ e => handleCityClick(e, city.label)}>{city.label}</NavLink></li>
      })}
    </ul>
  </div>
}

export default TopCities
